import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

interface ParamRedirectProps {
  fromPrefix: string;
  toPrefix: string;
}

const ParamRedirect: React.FC<ParamRedirectProps> = ({ fromPrefix, toPrefix }) => {
  const location = useLocation();
  const pathname = location.pathname;

  // Remove the fromPrefix and add the toPrefix
  const newPath = pathname.replace(fromPrefix, toPrefix);

  return <Navigate replace to={newPath} />;
};

export default ParamRedirect;
